// src/components/TableroSelector.js
import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Tabs,
  Tab,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { 
  DirectionsRun as RunningIcon,
  SportsScore as FieldIcon
} from '@mui/icons-material';

// Importa los componentes de los tableros
import ScoreboardTabs from './ScoreboardTabs';
import FieldScoreboardTabs from './Campo/FieldScoreboardTabs';

// Componente para el contenido de cada tab
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

/**
 * Componente selector para elegir entre tableros de pista o de campo
 */
const TableroSelector = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Estado compartido para las configuraciones
  const [configurations, setConfigurations] = useState(() => {
    const savedConfigs = localStorage.getItem('configurations');
    return savedConfigs ? JSON.parse(savedConfigs) : [];
  });

  // Estado compartido para ventanas abiertas
  const [openWindows, setOpenWindows] = useState({});
  
  // Manejar cambio de tabs
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  
  return (
    <Container maxWidth="100%" sx={{ py: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" textAlign="center">
        Gestión de Tableros
      </Typography>
      
      <Typography 
        variant="body1" 
        color="text.secondary" 
        sx={{ mb: 3 }} 
        textAlign="center"
      >
        Selecciona el tipo de tablero que deseas configurar o visualizar
      </Typography>
      
      <Paper elevation={3} sx={{ borderRadius: 2 }}>
        {/* Tabs de navegación */}
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
          variant="fullWidth"
          textColor="primary"
          indicatorColor="primary"
          aria-label="tipos de tableros"
          sx={{ 
            borderBottom: 1, 
            borderColor: 'divider',
            '& .MuiTab-root': {
              py: 2
            }
          }}
        >
          <Tab 
            icon={<RunningIcon />} 
            iconPosition="start" 
            label="Tableros de Pista" 
            id="tab-0"
            aria-controls="tabpanel-0"
          />
          <Tab 
            icon={<FieldIcon />} 
            iconPosition="start" 
            label="Tableros de Campo"
            id="tab-1"
            aria-controls="tabpanel-1"
            sx={{ color: theme.palette.secondary.main }}
          />
        </Tabs>
        
        {/* Contenido de cada tab */}
        <TabPanel value={tabValue} index={0}>
          <ScoreboardTabs 
            configurations={configurations}
            setConfigurations={setConfigurations}
            openWindows={openWindows}
            setOpenWindows={setOpenWindows}
          />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <FieldScoreboardTabs 
            configurations={configurations}
            setConfigurations={setConfigurations}
            openWindows={openWindows}
            setOpenWindows={setOpenWindows}
          />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default TableroSelector;